const headers = {
  name: "Branches",
  navigate: {
    tabs: [
      {
        name: "Settings",
        path: "/app/settings",
      },
      {
        name: "Branches",
        path: "/app/settings/branches",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
